module.exports = __webpack_public_path__ + "img/shareBar-bottom.32699717.png";